<template lang="pug">
.b-project-files
  BasePopup._popup-component(v-if="isOpened" @close="close" :zIndex="9999")
    ._popup
      ._btns.-right
        Btn(green @click="close") Сохранить
      slot(name="categories")
      //ProjectFileCategoryList(:items="categories" :selected="selectedCategory" :filesCount="fileCountInCategories" @select="$emit('selectCategory', $event)")
      FileDropzone._dropzone(@drop="$emit('upload', $event)")
      FileList._files(:files="filesInSelectedCategory"  @remove="$emit('delete', $event)" @toggle="$emit('toggle', $event)")
      ._btns
        Btn(blue @click="selectFilesInCategory") Выбрать все в папке
        Btn(green @click="close") Сохранить
</template>

<script>
import FileList from '@/components/FileList.vue';
import BasePopup from '@/components/BasePopup.vue';
import FileDropzone from '@/components/FileDropzone.vue';
import ProjectFileCategoryList from '@/components/ProjectFileCategoryList.vue';

export default {
  name: 'ProjectFileUploader',
  components: { ProjectFileCategoryList, FileDropzone, BasePopup, FileList }, // eslint-disable-line
  controller: null,
  props: {
    project: Number,
    selected: Array,
    allFiles: Array,
    uploadingFilesCount: Number,
    selectedCategory: Object,
  },
  data() {
    return {
      isOpened: false,
    };
  },
  computed: {
    filesInSelectedCategory() {
      return this.allFiles.filter((file) => file.category === this.selectedCategory?.['@id']);
    },
  },
  methods: {
    selectFilesInCategory() {
      this.$emit('select', this.filesInSelectedCategory.map(f => f['@id']));
    },
    open() {
      this.isOpened = true;

      return new Promise((resolve, reject) => {
        this.$options.controller = { resolve, reject };
      });
    },
    close() {
      if (this.uploadingFilesCount) {
        this.$alert('Пожалуйста, дождитесь окончания загрузки файлов или отмените загрузку.');
        return;
      }

      this.isOpened = false;
      this.$options.controller.resolve();
    },
  },
};
</script>

<style scoped lang="scss">
.project-files {
  &__popup {
    padding: 20px 40px 0;
    box-sizing: border-box;
    display: flex;
    gap: 30px;
    flex-direction: column;
    width: 883px;
    max-width: 100%;
  }

  &__dropzone {
    margin: 0 0 10px;
  }

  &__btns {
    display: flex;
    gap: 30px;
    justify-content: flex-end;

    &--right {
      justify-content: flex-start;
    }
  }

  @media (max-width: 768px) {
    ::v-deep .wrap {
      padding: 30px 20px;
    }

    &__popup {
      padding: 30px 0 0;
    }
  }
}
</style>
